export const HYDRATION_START_MARK = 'casino-next-hydration-start';
export const HYDRATION_END_MARK = 'casino-next-hydration-end';
export const HYDRATION_MEASURE = 'casino-next-hydration';
